<template>
  <v-app v-if="browserSize === `mobile`">
    <div class="finances-element">
      <v-card v-if="transaction.payable" class="my-element py-3 order">
        <div class="w-100 card-wrapper">
          <div class="wallet-part d-inline-block">
            <div class="wallet-wrapper py-4">
              <img src="../../../../public/img/images/icons8-basket-48.png" />
            </div>
          </div>
          <div class="text-part d-inline-block text-center">
            <div class="my-title-3 mb-3 text-color">
              سفارش شماره {{ transaction.id }}
            </div>
            <div class="dates text-center mb-2">
              <span>{{ jalali_date(transaction.pay_time) }}</span>
              <!-- _ -->
              <!-- <span>9:30</span> -->
            </div>
            <div class="number-accounts mb-2 my-title">
              <span>مبلغ </span>
              <span> {{ SeparatorNumber(transaction.payable) }}</span>

              <span> تومان</span>
            </div>
          </div>
          <div class="details-part text-center d-inline-block">
            <div class="details">
              <button @click="get_modal()">جزئیات</button>
            </div>
          </div>
        </div>
      </v-card>
      <v-card v-if="transaction.value" class="my-element deposit py-2">
        <div class="w-100 card-wrapper">
          <div class="wallet-part d-inline-block">
            <div class="wallet-wrapper py-4">
              <img src="../../../../public/img/icons/wallet-svgrepo-com.svg" />
            </div>
          </div>
          <div class="text-part d-inline-block text-center pt-1">
            <div class="my-title-3 mb-2">
              واریز شماره : {{ transaction.id }}
            </div>
            <div class="dates text-center mb-2">
              <span>{{ jalali_date(transaction.created_at) }}</span>
              <!-- _ -->
              <!-- <span>9:30</span> -->
            </div>
            <div v-if="transaction.desc && transaction.desc!=='undefined'" class="dates mb-2">
              <div>توضیح : </div>
              <div>
                {{ transaction.desc }}
              </div>
            </div>
            <div class="number-accounts mb-2 my-title">
              <span>مبلغ </span>
              <span>
                {{ SeparatorNumber(transaction.value) }}
              </span>
              <span> تومان</span>
            </div>
          </div>
        </div>
      </v-card>
    </div>
  </v-app>
</template>

<script>
import jalalim from "jalali-moment";
import Service from "../../../utils/seller-service";
import SeparatorNumber from "../../../utils/MyTools";
export default {
  name: "FinanceMobileView",
  props: ["transaction", "browserSize"],
  data: () => ({
    my_modal: false,
  }),
  methods: {
    SeparatorNumber(number) {
      return SeparatorNumber(number);
    },
    jalali_date: (this_date) => {
      return jalalim(this_date).locale("fa").format("YYYY/MM/DD");
    },
    get_modal() {
      this.my_modal = !this.my_modal;
      let modal_data = {
        show_data: this.transaction,
        my_modal: this.my_modal,
      };
      this.$emit("get_modal", modal_data);
    },
  },
  computed: {
    authService: function () {
      return Service(true);
    },
    theService: function () {
      return Service(false);
    },
  },
};
</script>

<style lang="scss" scoped>
.wallet-part {
  vertical-align: middle;
  width: 20%;
  position: relative;
  .wallet-wrapper {
    margin: 0 auto;
    width: 50px;
    img {
      width: 100%;
    }
  }
}
.text-part {
  width: 50%;
  vertical-align: middle;
}
.details-part {
  width: 30%;
  vertical-align: middle;
}
.deposit {
  background: #e8f4ff;
  .wallet-part {
    width: 20%;
  }
  .text-part {
    width: 70%;
  }
}
.card-wrapper {
  // margin-left: -3px;
  // margin-right: -3px;
  padding: 20px 0px;
}

.details {
  padding: 0 4px;
  button {
    border: solid 2px #d5cdff;
    border-radius: 10px;
    padding: 7px 15px;
    font-size: 12px;
    width: 100%;
    color: #7d6cd5;
    font-weight: 500;
    &:focus {
      outline: none;
    }
    &:hover {
      background: #e7eeff;
    }
  }
}
.dates {
  font-size: 13px;
  font-weight: 500;
  color: gray;
}
// .number-accounts {
//   color: palevioletred;
// }
</style>